import React from 'react';

function Icon({ width = '21', height = '22', fill = '#00214D' }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 21 22">
            <path
                fill={fill}
                d="M13.125 4v6.125H4.524l-.516.516-.508.508V4h9.625zM14 2.25H2.625a.878.878 0 00-.875.875v12.25l3.5-3.5H14a.878.878 0 00.875-.875V3.125A.878.878 0 0014 2.25zm4.375 3.5h-1.75v7.875H5.25v1.75c0 .481.394.875.875.875h9.625l3.5 3.5V6.625a.878.878 0 00-.875-.875z"
            ></path>
        </svg>
    );
}

export default Icon;
